import ProgramFormGrid from "../containers/ProgramFormGrid/ProgramFormGrid";

const ProgramPage = () => {
    return <ProgramFormGrid />;
};

export default ProgramPage;
